import { render, staticRenderFns } from "./message-abstract-file.vue?vue&type=template&id=2ebe5346&scoped=true"
import script from "./message-abstract-file.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-file.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-abstract-file.vue?vue&type=style&index=0&id=2ebe5346&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe5346",
  null
  
)

export default component.exports